import colors from "../../base/colors";
import typography from "../../base/typography";

const {  light, black } = colors;
const { fontWeightBold, fontWeightLight } = typography;
const listItemText = {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      color: black.main,
      fontWeight: fontWeightBold,
    },
    secondary: {
      color: light.main,
      fontWeight: fontWeightLight,
      textTranform: "lowercase",
    },
  },
};
export default listItemText;
